import { render, staticRenderFns } from "./StudentTeacherSlider.vue?vue&type=template&id=83917fea&scoped=true&"
import script from "./StudentTeacherSlider.vue?vue&type=script&lang=js&"
export * from "./StudentTeacherSlider.vue?vue&type=script&lang=js&"
import style0 from "./StudentTeacherSlider.vue?vue&type=style&index=0&id=83917fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83917fea",
  null
  
)

export default component.exports